// extracted by mini-css-extract-plugin
export default {"root":"styles_root__U9nLO","icon":"styles_icon__4Jwd1"};